export default [
  {
    path: 'scientific-information',
    name: 'scientific-information',
    component: () => import('@/views/pages/scientific-information/View.vue'),
    meta: {
      pageTitle: 'Scientific information',
      breadcrumb: [
        {
          text: 'Scientific information',
          active: true,
        },
      ],
    },
  },
]
